/** @module wgfractals/util/compute */
import { getDevice } from "../init.mjs";

// Encodes and submits a single compute pass — no GPU timestamp-query wrapping,
// since renderNow() in app.mjs times renders with a plain performance.now() diff instead.

/**
 * Finalises `commandEncoder` into a command buffer and submits it to the GPU queue.
 * @param {GPUCommandEncoder} commandEncoder
 */
export function submit(commandEncoder) {
  getDevice().queue.submit([commandEncoder.finish()]);
}

/**
 * Encodes a single compute pass: sets the pipeline and bind group, then
 * dispatches `workgroups`. Fractal renders always cover a width×height pixel
 * grid, so this only supports the 2D dispatch shape.
 * @param {GPUComputePipeline} pipeline
 * @param {GPUBindGroup} bindGroup
 * @param {{ x: number, y: number }} workgroups - from `calcWorkgroups(height, width)`
 * @returns {{ commandEncoder: GPUCommandEncoder }}
 */
export function runComputePass(pipeline, bindGroup, workgroups) {
  const device = getDevice();
  const commandEncoder = device.createCommandEncoder();
  const passEncoder = commandEncoder.beginComputePass();

  passEncoder.setPipeline(pipeline);
  passEncoder.setBindGroup(0, bindGroup);
  passEncoder.dispatchWorkgroups(workgroups.x, workgroups.y);

  passEncoder.end();

  return { commandEncoder };
}
